import { Validate } from "./Validate";

export interface Company {
  id: string;
  creationDate: Date;
  creationUser: string;
  lastModifiedDate: Date;
  lastModifiedUser: string;
  name: string;
  type: CompanyType;
  vatNumber: string;
  externalReference: string;
  logoUrl: string;
  logoDarkUrl: string;
  logoLightUrl: string;
  friendlyName?: string;
}

export interface CreateCompany {
  name: string;
  type: CompanyType;
}

export const defaultCreateCompany = (
  companyType: CompanyType
): CreateCompany => {
  return {
    name: "Senza nome",
    type: companyType,
  };
};

export const validate = (company: Company): Validate => {
  const validate: Validate = { isValid: true, errors: {} };
  return validate;
};

export type CompanyType =
  | "CUSTOMER"
  | "AFILIATE"
  | "ORGANIZATION"
  | "MASTER_ORGANIZATION";
